


const Navbar = () => {
   
  
    return (
        
      <nav>
      
            <img className="navBar__img" src="/logo.png" alt=""/>


        </nav>
    );
  }
  
  export default Navbar;